"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormatSupplies = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var components_1 = require("../../../../../../shared/core/components");
var components_2 = require("../../../../components");
var CallToActionSection_1 = require("../../../../components/MeterReadingSummaryCard/CallToActionSection");
var get_ctas_1 = require("../../../../components/MeterReadingSummaryCard/get-ctas");
var utils_1 = require("../../../../components/MeterReadingsData/utils");
var copy_1 = require("../../../../copy");
var utils_2 = require("../../../../utils");
var SupplyMessages_1 = require("./SupplyMessages");
var useFormatSupplies = function (_a) {
    var supplies = _a.supplies, readings = _a.readings, fuel = _a.fuel, supplyIndexStart = _a.supplyIndexStart, isComplex = _a.isComplex;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return supplies.map(function (_a, key) {
        var isSmart = _a.isSmart, isNonComms = _a.isNonComms, mpxn = _a.mpxn, registers = _a.registers, supplyIsOnboarding = _a.isOnboarding, isInOMRWindow = _a.isInOMRWindow, meterNumOfDigits = _a.meterNumOfDigits, isSupplyPointInfoValid = _a.isSupplyPointInfoValid;
        var supplyReads = (0, utils_2.filterReadsMPXN)(readings, mpxn);
        var latestActualReading = (0, utils_1.getLatestManualReading)(supplyReads);
        // There is some complexity around what "onboarding" means, this mirrors
        // existing logic.
        var isOnboarding = supplyIsOnboarding || !isSupplyPointInfoValid;
        var missingSprn = !mpxn;
        var hasCommunicatingSmartMeter = isSmart && !isNonComms;
        var showRegisters = !(hasCommunicatingSmartMeter && !isOnboarding) &&
            !(isOnboarding && !isInOMRWindow);
        var showTimingCategory = registers && (isComplex || registers.length > 1);
        var showSmartMeterMessage = isSmart && !isOnboarding;
        var actions = (0, get_ctas_1.getCTAs)({
            isSmart: isSmart,
            isNonComms: isNonComms,
            hasRecentManualReading: !!latestActualReading,
            isOnboarding: isOnboarding,
            isInOMRWindow: isInOMRWindow,
        });
        var mapRegisters = function (registers) {
            return registers
                ? registers.map(function (_a) {
                    var timingCategory = _a.timingCategory;
                    var timeOfUseLabel = timingCategory
                        ? (0, utils_2.timingCategoryToTimeOfUseLabel)(timingCategory)
                        : null;
                    return {
                        timingCategory: showTimingCategory ? timingCategory : undefined,
                        context: latestActualReading && timeOfUseLabel ? (react_1.default.createElement(components_2.LatestReadWithDate, { reading: latestActualReading, timeOfUseLabel: timeOfUseLabel, meterNumOfDigits: meterNumOfDigits })) : (react_1.default.createElement(Copy, { copyKey: "noLatestRead" })),
                    };
                })
                : [
                    {
                        context: latestActualReading ? (react_1.default.createElement(components_2.LatestReadWithDate, { reading: latestActualReading, meterNumOfDigits: meterNumOfDigits })) : (react_1.default.createElement(Copy, { copyKey: "noLatestRead" })),
                    },
                ];
        };
        return {
            sprn: mpxn || undefined,
            registers: showRegisters ? mapRegisters(registers) : [],
            children: showSmartMeterMessage || missingSprn ? (react_1.default.createElement(components_1.IconSummarySpacer, null,
                react_1.default.createElement(SupplyMessages_1.SupplyMessages, { missingSprn: missingSprn, isSmart: isSmart, isNonComms: isNonComms, isOnboarding: isOnboarding, fuel: fuel }))) : null,
            footer: !missingSprn ? (react_1.default.createElement(CallToActionSection_1.CallToActionSection, { actions: actions, fuelType: fuel, isSmart: isSmart, supplyIndex: supplyIndexStart + key })) : undefined,
        };
    });
};
exports.useFormatSupplies = useFormatSupplies;
